import React from "react";
import "../css/Viewpage.css";
import logo from "../images/logo.jpeg";
import { useNavigate, useLocation } from "react-router-dom";

function TermsAndConditions() {
    const navigation = useNavigate();
    const location = useLocation();

    const isFromRegistration = location.state?.isFromRegistration;

    // Home button
    const handleHomeClick = () => {
        if (isFromRegistration) {
            return;
        }

        navigation("/Viewpage");
    };

    // Back button
    const handleBackClick = () => {
        navigation("/", { replace: true });
    };

    // Disable right click
    const disableRightClick = (e) => {
        e.preventDefault();
    };

    return (
        <div
            className="terms-page"
            onContextMenu={disableRightClick}
        >

            {/* ================= HEADER ================= */}
            <header className="top-bar shadow-sm">
                <div className="container">
                    <div className="terms-header">

                        {isFromRegistration ? (
                            /* ---------- BACK BUTTON ---------- */
                            <button
                                type="button"
                                className="terms-back-btn"
                                onClick={handleBackClick}
                            >
                                <i className="bi bi-arrow-left me-2"></i>
                                Back
                            </button>
                        ) : (
                            /* ---------- LOGO + HOME ---------- */
                            <>
                                <img
                                    src={logo}
                                    alt="IndiaMetti Logo"
                                    className="terms-logo"
                                    onClick={handleHomeClick}
                                />

                                <button
                                    type="button"
                                    className="terms-home-btn"
                                    onClick={handleHomeClick}
                                >
                                    <i className="bi bi-house me-1"></i>
                                    Home
                                </button>
                            </>
                        )}

                    </div>
                </div>
            </header>


            {/* ================= CONTENT ================= */}
            <main className="terms-content">

                <div className="terms-container">

                    <h1 className="terms-title">
                        Terms and Conditions
                    </h1>

                    <p className="terms-updated">
                        Last Updated: May 2026
                    </p>


                    {/* 1. Agreement to Terms */}
                    <section className="terms-section">
                        <h4>1. Agreement to Terms</h4>

                        <p>
                            By accessing or using IndiaMetti, you agree to be
                            bound by these Terms and Conditions and our Privacy
                            Policy. If you do not agree to all of these terms,
                            do not use our services.
                        </p>
                    </section>


                    {/* 2. Eligibility */}
                    <section className="terms-section">
                        <h4>2. Eligibility</h4>

                        <p>
                            To register as a member of IndiaMetti or use this
                            website, you must be of legal marriageable age as
                            per the laws of India (currently 18 years or over
                            for females and 21 years or over for males). Our
                            platform is strictly for matrimonial purposes and
                            not for dating or casual hookups.
                        </p>
                    </section>


                    {/* 3. Account Security */}
                    <section className="terms-section">
                        <h4>3. Account Security</h4>

                        <p>
                            You are responsible for maintaining the
                            confidentiality of your login credentials. You are
                            solely responsible for all activities that occur
                            under your account. You agree to notify us
                            immediately of any unauthorized use of your account.
                        </p>
                    </section>


                    {/* 4. User Conduct and Content */}
                    <section className="terms-section">
                        <h4>4. User Conduct and Content</h4>

                        <ul>
                            <li>
                                You will provide accurate, current, and complete
                                information during registration.
                            </li>

                            <li>
                                You will not post defamatory, blasphemous,
                                obscene, or offensive content.
                            </li>

                            <li>
                                You will not use the service to harass, abuse,
                                or harm another person.
                            </li>

                            <li>
                                We reserve the right to review and delete any
                                content that violates these terms.
                            </li>
                        </ul>
                    </section>


                    {/* 5. Privacy and Communication */}
                    <section className="terms-section">
                        <h4>5. Privacy and Communication</h4>

                        <p>
                            Your use of the platform is subject to our Privacy
                            Policy. By using IndiaMetti, you consent to receive
                            communications from us and other members through
                            the contact details provided in your profile.
                        </p>
                    </section>


                    {/* 6. Paid Memberships */}
                    <section className="terms-section">
                        <h4>6. Paid Memberships</h4>

                        <p>
                            Membership fees are non-refundable under any
                            circumstances. Packages and prices are subject to
                            change without notice. Paid features are intended
                            to facilitate matchmaking but do not guarantee a
                            successful match.
                        </p>
                    </section>


                    {/* 7. Limitation of Liability */}
                    <section className="terms-section">
                        <h4>7. Limitation of Liability</h4>

                        <p>
                            IndiaMetti is a platform for matchmaking. We do not
                            verify the character or creditworthiness of members.
                            We are not responsible for any loss or damage
                            resulting from your interactions with other users,
                            whether online or offline.
                        </p>
                    </section>


                    {/* 8. Account Termination */}
                    <section className="terms-section">
                        <h4>8. Account Termination</h4>

                        <p>
                            We reserve the right to terminate or suspend your
                            account at our sole discretion, without notice, for
                            conduct that we believe violates these Terms and
                            Conditions or is harmful to other users of the
                            platform.
                        </p>
                    </section>


                    {/* 9. Governing Law */}
                    <section className="terms-section">
                        <h4>9. Governing Law</h4>

                        <p>
                            These terms shall be governed by and construed in
                            accordance with the laws of India. Any disputes
                            arising under or in connection with these terms
                            shall be subject to the exclusive jurisdiction of
                            the courts in Tamil Nadu.
                        </p>
                    </section>


                    {/* 10. Contact Information */}
                    <section className="terms-section">
                        <h4>10. Contact Information</h4>

                        <p>
                            For any legal inquiries regarding these terms,
                            please contact:
                        </p>

                        <div className="terms-contact-card">

                            <p>
                                <strong>Legal Dept:</strong>{" "}
                                IndiaMetti.com
                            </p>

                            <p>
                                <strong>Email:</strong>{" "}
                                legal@indiametti.com
                            </p>

                            <p>
                                <strong>Address:</strong>{" "}
                                NavGraph Technologies, Chennai, India.
                            </p>

                        </div>
                    </section>

                </div>

            </main>


            {/* ================= FOOTER ================= */}
            <footer className="terms-footer">
                <label>
                    Copyright © 2026 NavGraph Technologies. All Rights Reserved.
                </label>
            </footer>

        </div>
    );
}

export default TermsAndConditions;